<template>
  <Head title="Forgot Password" />
  <GuestLayout showExtras="true" headingTitle="Esqueci Minha Senha" :showBottomBarInDesktop="true">
    <article>

      <div class="sm:px-5 xl:max-w-[350px]">
        <h2 class="text-3xl font-semibold text-left xl:py-6 sm:py-4 pb:text-hover sm:hidden">Esqueci Minha Senha</h2>
        <p class="pb-2 text-sm pb:text-white">
          Para recuperar a senha, precisamos verificar se é você mesmo.
        </p>

        <p class="text-sm pb:text-white">
          Digite seu email cadastrado e nós enviaremos um código de verificação.
        </p>

        <form @submit.prevent="submit">
          <ul class="grid gap-5 pt-4">
            <li>
              <label class="mb-1 mr-5 flex font-semibold pb-1 pb:text-white"> Email </label>
              <Input
                placeholder="Exemplo: joao@email.com"
                id="email"
                type="email"
                v-model="form.email"
                required
                autofocus
                autocomplete="username"
              />
            </li>

            <li>
              <Button
              :enabled="allIsValid"
              >
                Enviar Código
              </Button>

            </li>
          </ul>

        </form>
            <div class="text-xs text-error" v-if="$page.props.flash.error">
                {{ $page.props.flash.error }}
            </div>

            <div v-if="$page.props.flash.success">
                {{ $page.props.flash.success }}
            </div>
      </div>

    </article>
    </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";

import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import Button from "@/Components/Button.vue";

export default {
  components: {
    Button,
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    GuestLayout,
  },

  props: {
    status: String,
  },

  computed: {
      allIsValid: function() {
          return this.form.email ? true : false
      }
  },
  data() {
    return {
      form: this.$inertia.form({
        email: "",
      }),
      inputClasses:
        "overflow-visible py-1 px-3 m-0 w-full h-12 text-xs font-normal text-white bg-clip-padding bg-transparent rounded-none border-b border-white border-solid box-border outline-none mt-1 block w-full",
    };
  },

  methods: {
    submit() {
      if(this.form.email) {

        this.$inertia.post('/forgot-password', this.form);
        sessionStorage.setItem('recoveryEmail', this.form.email);
      }
    },
  },
};
</script>
